import { writable } from 'svelte/store';

export const shouldResetRebateTableDropdowns = writable(false);